import * as types from "@root/types";
import { useMemo, useState } from "react";

type UseArtistsHookResult = {
  artists: types.Artist[];
  query: string | undefined;
  updateQuery: (q?: string) => void;
};

type UseArtistsHook = (
  artists: types.Artist[],
  initialQuery?: string,
) => UseArtistsHookResult;

const useFilterArtists: UseArtistsHook = (artists, initialQuery) => {
  const [query, setQuery] = useState<string | undefined>(initialQuery);

  const artistsFilter = useMemo(() => {
    if (!query) {
      return (_artist: types.Artist) => true;
    }
    const matcher = query.toLowerCase();
    return (artist: types.Artist) => {
      const content = [
        artist?.fullName,
        artist?.nomDePlume,
        artist?.firstName,
        artist?.lastName,
      ]
        .join(" ")
        .toLowerCase();
      return !!content.match(matcher);
    };
  }, [query]);

  const filteredArtists = (artists || []).filter(artistsFilter);
  return { artists: filteredArtists, query, updateQuery: setQuery };
};

export { useFilterArtists };
